class Donation {

	constructor() {
		this.init();
	}

	init() {
    var selectedArea = '',
        selectedJour = '';

    $(document).on('click', '.donation .buttons button', function(e){
      $('.donation .buttons button.btn-primary').removeClass('btn-primary').removeClass('toggled').addClass('btn-secondary');
      $(this).removeClass('btn-secondary').addClass('btn-primary').addClass('toggled');
      $('.donation-footer').addClass('d-none');

      $('.donation-footer.'+$(this).data('target')).removeClass('d-none');
    });

    $(document).on('change', 'select.choose-area', function(e){
      var optionSelected = $('option:selected', this);
      selectedArea = this.value;

      $('.specific-details').html('');
      $('select.choose-jour').prop('disabled', false);
      $('select.choose-jour option.appended').remove();

      console.log(this.value);

      $.each(areas[this.value], function(key, value){
        console.log(key);
        $('select.choose-jour').append('<option class="appended" value="'+key+'">'+key+'</option>');
      });

      $('select.choose-jour option:eq(0)').prop('selected', true);
    });

    $(document).on('change', 'select.choose-jour', function(e){
      var optionSelected = $('option:selected', this);

      if(!this.value) return;

      $('.specific-details').html('');
      $('.specific-details').append('<h3>' + this.value + '</h3>');
      $('.specific-details').append(areas[selectedArea][this.value]);
    });
	}
}

export default Donation;
